var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"iframeContainer",staticClass:"iframe-newhero-container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.newHeroURL,"frameborder":"0","scrolling":"no","onload":_vm.resizeIframe(),"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }